import type { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon as FontAwesomeIconComponent } from '@fortawesome/react-fontawesome'
import type { VariantProps } from 'cva'
import { cva } from 'cva'
import type { ComponentProps, FC } from 'react'

const iconVariants = cva({
	base: 'flex items-center justify-center',
	variants: {
		size: {
			xs: 'w-3.75 h-3.75 text-(length:--size-icon-xs)', // 15px / 12px
			sm: 'w-4 h-4 text-(length:--size-icon-sm)', // 16px / 16px
			md: 'w-5 h-5 text-(length:--size-icon-md)', // 20px / 16px
			lg: 'w-6 h-6 text-(length:--size-icon-md)', // 24px / 16px
			xl: 'w-7.5 h-7.5 text-(length:--size-icon-xl)', // 30px / 24px
			'2xl': 'w-8 h-8 text-(length:--size-icon-2xl)', // 32px / 25px
			'3xl': 'w-10 h-10 text-(length:--size-icon-3xl)', // 40px / 32px
			responsive:
				'w-3.75 h-3.75 text-(length:--size-icon-xs) tablet-l:w-5 tablet-l:h-5 tablet-l:text-(length:--size-icon-md)', // 20px / 15px, tablet-l: 20px / 16px
		},
	},
	defaultVariants: {
		size: 'md',
	},
})

type IconVariants = VariantProps<typeof iconVariants>

export type FontAwesomeIconProps = ComponentProps<'div'> &
	IconVariants & {
		icon: [IconPrefix, IconName]
	}

export const FontAwesomeIcon: FC<FontAwesomeIconProps> = ({ icon, className, size, ...props }) => {
	if (!icon || !icon[1] || !icon[0]) {
		return null
	}

	return (
		<span className={iconVariants({ size, className })} {...props}>
			<FontAwesomeIconComponent icon={icon} aria-hidden="true" className="!w-[1em]" />
		</span>
	)
}
